'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconValueRight = require('../Icon/IconValue/IconValueRight');

var InputText = React.createClass({
    displayName: 'InputText',


    getDefaultProps: function getDefaultProps() {
        return {
            valid: true,
            className: "",
            rightIcon: undefined,
            width: "inherit",
            type: "text",
            autoComplete: "on",
            maxLength: undefined,
            placeholder: "",
            onChange: function onChange() {},
            onEnter: function onEnter() {},
            onBlur: function onBlur() {}
        };
    },

    focus: function focus() {
        this.refs.input.focus();
    },

    onKeyUp: function onKeyUp(e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();
            this.props.onEnter(e);
        }
    },

    render: function render() {
        var className = ["input-text", this.props.className, this.props.valid == false ? "invalid" : ""].join(" ");
        var style = { width: this.props.width };

        var moreProps = {};
        if (this.props.maxLength != undefined) {
            moreProps.maxLength = this.props.maxLength;
        }

        return React.createElement(
            IconValueRight,
            { className: className, icon: this.props.rightIcon },
            React.createElement('input', _extends({ ref: 'input',
                type: this.props.type,
                value: this.props.value,
                style: style,
                placeholder: this.props.placeholder,
                autoComplete: this.props.autocomplete,
                onChange: this.props.onChange,
                onKeyUp: this.onKeyUp,
                onBlur: this.props.onBlur
            }, moreProps))
        );
    }
});

module.exports = InputText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/InputText.js
// module id = 594
// module chunks = 0 1 2 4 10 17 18 22 25 26 28 29 30